import styled from "styled-components";

const BORDER = "#ddd";
const INPUT_BORDER = "#c5c6ca";
const TEXT_DARK = "#19191b";
const TEXT_MUTED = "#a1a2a7";
const PLACEHOLDER = "#a1a2a7";
/** Figma error tokens: border-destructive-active (#ff2d2d) + foreground-destructive (#c50707). */
const ERROR_BORDER = "var(--color-border-destructive-active, #ff2d2d)";
const ERROR_TEXT = "var(--color-foreground-destructive, #c50707)";

/** Centres the verify card in the wizard body (both axes), per Figma. */
export const CardCenter = styled.div`
  display: flex;
  flex: 1 0 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 400px;
  max-width: 100%;
  padding: 40px;
  background: var(--color-white-100, #fff);
  border: 1px solid ${BORDER};
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
`;

export const Title = styled.h1`
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 20px;
  line-height: 28px;
  color: ${TEXT_DARK};
`;

export const Description = styled.p`
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${TEXT_DARK};
`;

export const Instructions = styled.p`
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${TEXT_DARK};
`;

/** Groups the input with its inline error message at the tight 2px Figma gap. */
export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
`;

export const InputRow = styled.div`
  position: relative;
  width: 100%;
`;

export const CodeInput = styled.input<{ $error: boolean }>`
  width: 100%;
  height: 44px;
  /* Symmetric padding so the code stays centred; the spinner/error icon float
     over the input as absolute overlays (see Spinner/ErrorIcon) rather than
     occupying a right gutter that would push the text off-centre. */
  padding: 0 16px;
  background: #fff;
  border: 1px solid ${({ $error }) => ($error ? ERROR_BORDER : INPUT_BORDER)};
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: 8px;
  color: ${({ $error }) => ($error ? ERROR_TEXT : TEXT_DARK)};
  outline: none;

  &::placeholder {
    font-weight: 900;
    color: ${PLACEHOLDER};
  }
`;

/** Right-floating overlay slot shared by the spinner and the error icon. */
export const Spinner = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
`;

export const ErrorIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  display: flex;
  font-size: 20px;
  color: ${ERROR_TEXT};
`;

export const ErrorText = styled.p`
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${ERROR_TEXT};
`;

export const ResendLink = styled.p`
  width: fit-content;
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${TEXT_DARK};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Countdown = styled.p`
  /* Same line-height as ResendLink so swapping link ⇄ countdown never changes
     the card height. */
  margin: 0;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: ${TEXT_MUTED};
`;
